'use strict';

const LOCAL_STORAGE_KEY = 'tempUser';
const temporaryUser = [
  'Storage',

  function (Storage) {
    var localStorage = new Storage(Storage.hasLocalStorage ? 'local' : 'memory');

    return {
      setData: function (data) {
        if (angular.isObject(data)) {
          localStorage.set(LOCAL_STORAGE_KEY, JSON.stringify(data));
        }
      },
      getData: function () {
        var data = null;

        try {
          data = JSON.parse(localStorage.get(LOCAL_STORAGE_KEY));
        } catch (error) {
          return;
        }

        return data;
      },
      remove: function () {
        localStorage.remove(LOCAL_STORAGE_KEY);
      }
    };
  }
];

export default temporaryUser;



// WEBPACK FOOTER //
// ./app/src/services/temporary_user.js